<template>
  <div v-if="show" class="auth-loading-screen">
    <div class="auth-loading-screen__content">
      <div class="auth-loading-screen__spinner"></div>
      <h2 class="auth-loading-screen__title">Loading...</h2>
      <p class="auth-loading-screen__message">Verifying your session</p>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore();

// Show loading screen while auth is initializing
const show = ref(authStore.initializing);

// Watch for loading state changes
watch(
  () => authStore.initializing,
  (newValue) => {
    show.value = newValue;
  }
);
</script>

<style scoped>
.auth-loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: var(--z-modal-backdrop);
  background: var(--color-bg-primary);
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-loading-screen__content {
  text-align: center;
  padding: var(--space-2xl);
}

.auth-loading-screen__spinner {
  width: 48px;
  height: 48px;
  margin: 0 auto var(--space-xl);
  border: 4px solid var(--color-border-light);
  border-top: 4px solid var(--color-accent);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.auth-loading-screen__title {
  margin: 0 0 var(--space-sm) 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.auth-loading-screen__message {
  margin: 0;
  font-size: var(--font-size-base);
  color: var(--color-text-secondary);
}
</style>

